// extracted by mini-css-extract-plugin
module.exports = {"captionBox":"style__captionBox__ZsQAY","formBox":"style__formBox__IX+oM","regMsg":"style__regMsg__anDtx","logMsg":"style__logMsg__8Ycp5"};